import * as rxjs from 'rxjs';

export default class EventBus {
    searchReset = new rxjs.Subject();
    closeEditEvent = new rxjs.Subject();
    viewDetailEvent = new rxjs.Subject();
    programChangeEvent = new rxjs.Subject();
    successfulEditEvent = new rxjs.Subject();

    nextSearchReset() {
        this.searchReset.next();
    }
    nextCloseEdit() {
        this.closeEditEvent.next();
    }
    nextViewDetail() {
        this.viewDetailEvent.next();
    }
    nextProgramChange() {
        this.programChangeEvent.next();
    }
    nextSuccessfulEdit() {
        this.successfulEditEvent.next();
    }
}
